import {
  Box,
  Button,
  InputAdornment,
  Popper,
  TextField,
  Tooltip,
  useTheme,
} from '@mui/material';
import { useEffect, useRef, useState } from 'react';
import TextSnippetIcon from '@mui/icons-material/TextSnippet';
import { tokens } from '../../../global/theme/tokens';
import { ECTextBlocks } from '../../email-system/ECTextBlocks';
import ExoDialog from '../../exo/ExoDialog';
import { useTranslation } from 'react-i18next';
const TypeText = ({
  field,
  dataCollection,
  errors = {},
  updateValidationOnChange,
  size,
  onFocus,
  onBlur,
}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode, theme.palette.colorTheme);
  const { t } = useTranslation();

  const {
    colspan,
    textBlockType,
    label,
    key,
    multiline,
    minRows,
    placeholder,
    autoComplete,
    autoCorrect,
    disabled,
    unit,
    focusOnMount,
  } = field;

  function handleTextChange(value) {
    updateValidationOnChange([key], value.target.value);
  }
  const inputRef = useRef(null);

  useEffect(() => {
    if (focusOnMount) {
      inputRef.current?.focus();
    }
  }, [focusOnMount]);

  // text blocks
  const [openTextBlocks, setOpenTextBlocks] = useState(false);

  return (
    <Box className="flex gap-2 w-full">
      <TextField
        sx={{
          gridColumn: colspan ? `span ${colspan} / span ${colspan}` : 'auto',
          width: '100%',
        }}
        size={size}
        label={label}
        value={dataCollection[key] || ''}
        onChange={handleTextChange}
        multiline={multiline ? true : false}
        minRows={multiline ? minRows : undefined}
        placeholder={placeholder}
        InputProps={{
          endAdornment: unit ? (
            <InputAdornment position="end">{unit}</InputAdornment>
          ) : null,
          inputRef,
        }}
        // Autocorrect/spellcheck off by default — most text fields hold names,
        // codes or abbreviations. Opt back in per field with `autoCorrect: true`
        // (e.g. prose-style notes). Rich text fields are unaffected.
        inputProps={{
          autoCorrect: autoCorrect ? 'on' : 'off',
          autoCapitalize: autoCorrect ? 'sentences' : 'off',
          spellCheck: Boolean(autoCorrect),
        }}
        onFocus={onFocus}
        onBlur={onBlur}
        autoComplete={autoComplete ?? 'on'}
        disabled={disabled}
      />

      {textBlockType && (
        <>
          <Tooltip title={t('Quick name selection')}>
            <Button
              sx={{
                bgcolor: colors.bgInput,
                border: `1px solid ${colors.selected}`,
                borderRadius: '10px',
                minWidth: size === 'small' ? '40px' : '53px',
                ':hover': {
                  border: `1px solid ${colors.info}80`,
                },
              }}
              onClick={() => setOpenTextBlocks(true)}
            >
              <TextSnippetIcon />
            </Button>
          </Tooltip>
          <ExoDialog
            open={openTextBlocks}
            onClose={() => setOpenTextBlocks(false)}
          >
            <ECTextBlocks
              onSelect={(e) => {
                updateValidationOnChange([key], e.text);
                setOpenTextBlocks(false);
              }}
              type={textBlockType}
              useHtml={false}
            />
          </ExoDialog>
        </>
      )}
    </Box>
  );
};

export default TypeText;
